import { getImageUrl } from "@/utils/getImageUrl";
import type { FormatOptions } from "@bitpatty/imgproxy-url-builder";
import { forwardRef, useMemo } from "react";

export const Image = forwardRef<
	HTMLImageElement,
	React.ImgHTMLAttributes<HTMLImageElement> & {
		src: string;
		width?: number;
		height?: number;
		quality?: number;
		format?: FormatOptions;
	}
>(({ src, width, height, quality, format, ...props }, ref) => {
	const imageUrl = useMemo(() => {
		return getImageUrl(src, { width, height, quality, format });
	}, [src, width, height, quality, format]);

	if (!imageUrl) {
		return null;
	}

	return <img ref={ref} alt={props.alt} {...props} src={imageUrl} />;
});
